<template>
  <div class="page-container">
    <!-- Кривая линия -->
    <div class="curve-line" v-if="showCurve">
      <svg class="curve-svg" viewBox="0 0 100 1000" preserveAspectRatio="none">
        <path class="curve-path" d="M50,0 C70,50 30,150 50,200 C70,250 30,350 50,400 C70,450 30,550 50,600 C70,650 30,750 50,800 C70,850 30,950 50,1000" />
      </svg>
    </div>
    
    <section class="silimed">
      <h2 class="section-title animate-element" ref="sectionTitle">{{ $t('silimed.start')}}</h2>

      

      <div class="silimed-text animate-element" ref="silimedText">
        <p>{{ $t('silimed.target')}}</p>
        <p>{{ $t('silimed.misiion')}}</p>
        <h3>{{ $t('silimed.newfactory')}}</h3>
         <p>{{ $t('silimed.location')}}</p>  

      </div>
    </section>
    
    <section class="features">
      <h2 class="features-title">{{ $t('silimed.title')}}</h2>
      <div class="features-block">
        <div class="block-text">
          <p>{{ $t('silimed.id')}}</p>
        </div>
        <div class="block-text">
          <p>{{ $t('silimed.cer')}}</p>
        </div>
      </div>
    </section>
    <div class="btn-vue-router" @click="goToBreands">{{ $t('silimed.next')}}</div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MainImplants',

  data() {
    return {
      showCurve: true
    }
  },

  setup() {
    const router = useRouter()

    function goToBreands() {
      router.push("/invo")
    }

    return { goToBreands }
  },

  mounted() {
    this.initAnimations()
    window.addEventListener('resize', this.handleResize)
    this.handleResize() // Проверка при монтировании
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    switchLang(lang) {
      this.$i18n.locale = lang
    },

    initAnimations() {
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line')
          if (curveLine) {
            curveLine.classList.add('animate-curve')
          }
        }, 100)
      }

      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect()
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        )
      }

      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element')
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate')
          }
        })
      }

      window.addEventListener('load', handleScroll)
      window.addEventListener('scroll', handleScroll)
      handleScroll()
    },

    handleResize() {
      this.showCurve = window.innerWidth > 768
    }
  }
}
</script>


<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

* h3 {
  color: #0d1016;
  font-size: 20px;
  font-weight: 100;
  line-height: normal;
  margin-bottom: 25px;
}

.btn-vue-router {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-size: 20px;
  color: white;
  background-color: #108381;
  border: 1px solid white;
  width: 250px;
  height: 50px;
  transition: 300ms;
  cursor: pointer;
}

.btn-vue-router:hover {
  color: #108381;
  background-color: white;
  border: 1px solid #108381;
}

/* Контейнер для всей страницы с отступом */
.page-container {
  position: relative;
  max-width: 1200px;
  margin: 70px auto;
  padding: 0 20px;
}

.section-title{
  color: #505050;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 100px;
  text-align: center;
}

.features-title {
  font-family: "Roboto";
  font-size: clamp(18px, 2vw, 22px);
  font-weight: 500;
  margin-bottom: 30px;
  text-align: center;
}

.features-block {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.block-text {
  flex: 1;
  min-width: 280px;
  max-width: 560px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  padding: 20px;
  font-size: clamp(14px, 1.2vw, 18px);
  line-height: 1.6;
  text-align: center;
  color: #000;
  border-radius: 8px;
}


.download-link {
  display: inline-block;
  margin-top: 10px;
  color: teal;
  text-decoration: none;
  font-weight: bold;
}

.download-link:hover {
  text-decoration: underline;
}

/* ===== Silimed section ===== */

.silimed {
  text-align: center;
  margin: 0 auto;
  max-width: 1200px;
}

.silimed-banner{
  margin-bottom: 30px;
  padding: 5px;
  border: 1px solid rgba(15, 131, 129, .14);
}

.silimed-banner img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}

.silimed-text {
  max-width: 1160px;
  margin: 0 auto;
  text-align: left;
}

.silimed-text h2 {
  color: #0d1016;
  font-size: 30px;
  font-weight: 100;
  line-height: normal;
  margin-bottom: 25px;
}

.silimed-text p {
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  color: #555;
  font-size: 18px;
}

/* Анимационные стили */
.animate-element {
  transform: translateX(-100px);
  opacity: 0;
  transition: transform 0.8s ease-out, opacity 0.8s ease;
}

.animate {
  transform: translateX(0) !important;
  opacity: 1 !important;
}

/* Кривая линия - перемещена левее контента */
.curve-line {
  position: absolute;
  top: 0;
  left: -80px;
  width: 100px;
  height: 100%;
  z-index: -1;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

.curve-path {
  fill: none;
  stroke: #0b8482;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: stroke-dashoffset 2s ease-in-out;
}

.animate-curve .curve-path {
  stroke-dashoffset: 0;
}

.features-title{
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
}

.block-text {
  margin-top: 30px;
  width: 560px;
  height: 190px;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  padding: 29px 15px;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #000000;
}

/* === Кнопка перехода === */
.btn-vue-router {
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-size: clamp(16px, 1.5vw, 20px);
  color: white;
  background-color: #108381;
  border: 1px solid white;
  width: clamp(200px, 30%, 250px);
  height: 50px;
  transition: 300ms;
  cursor: pointer;
  border-radius: 6px;
}
.btn-vue-router:hover {
  color: #108381;
  background: white;
  border: 1px solid #108381;
}


/* Адаптация для мобильных устройств */
@media (max-width: 768px) {
  .page-container {
    padding: 0 15px;
    margin: 40px auto;
  }
  
  .curve-line {
    display: none; /* Скрываем линию на мобильных */
  }
  
  .animate-element {
    transform: translateX(-50px); /* Меньшее смещение для мобильных */
  }
  
  .silimed-buttons {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }
  
  .silimed-buttons a {
    width: 100%;
    line-height: 50px;
  }
  
  .features {
    flex-direction: column;
    align-items: center;
  }
  
  .feature-card {
    max-width: 100%;
    min-height: auto;
    margin-bottom: 30px;
  }
  .block-text{
    height: 100%;
  }
}
</style>